import React, { Component } from 'react'
import { RequiredSharedRoomComponent, RequiredSharedRoomForElectives } from './'
import lodashUtil from 'lodash';
import { DialogComponentUtil } from '..';
import { ConstraintsAndPreferences, CalculateUtil } from '..';
import { rulesUtil } from '../index'
export class RequiredSharedRoomContainer extends Component {
	constructor(props) {
		super(props)
		let cellData = this.props.dataTableMap.get(this.props.cellCode)
		let sharedRoomsForSubject = {};
		let sharedRoomsForElective = {};

		if (cellData.elective !== undefined) {
			let subjects = [];
			for (let i = 0; i < cellData.elective.subjects.length; i++) {
				let subject = cellData.elective.subjects[i];
				let subjectObj = {
					subjectId: subject._id,
					subjectName: subject.name,
					subjectCode: subject.subjectCode,
					rooms: []
				}
				subjects.push({ ...subjectObj })
			}
			sharedRoomsForElective = {
				electiveName: cellData.elective.name,
				electiveId: cellData.elective._id,
				subjects: subjects,
			}
		} else {
			sharedRoomsForSubject = {
				subjectId: cellData.subject._id,
				subjectName: cellData.subject.name,
				subjectCode: cellData.subject.code,
				room: []
			}
		}
		this.state = {
			keyArray: [],
			tempActiveSchool: this.props.activeSchool,
			sharedRoomsForSubject: JSON.parse(JSON.stringify(sharedRoomsForSubject)),
			sharedRoomsForElective: sharedRoomsForElective,
			isElective: false,
			school_sharedRooms: this.props.activeSchool.school_master.sharedRooms,
			requiredRoom: [],
			// room: [],
			sharedRoomsForSubjects: {},
			numOfRoom: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects)),
			elective: undefined,

		}
	}

	handleChangeName = (name, event, value) => {
		let requiredRoom = []
		requiredRoom = value
		this.setState({
			requiredRoom: requiredRoom
		})

	}

	handleChangeNameforElective = (event, value, index) => {
		let tempElectiveObj = JSON.parse(JSON.stringify(this.state.sharedRoomsForElective));
		tempElectiveObj.subjects[index].rooms = []
		for (let i = 0; i < value.length; i++) {
			let tempObj = value[i];
			let roomObj = {
				roomId: tempObj._id,
				name: tempObj.name,
				roomCode: tempObj.roomCode
			}
			tempElectiveObj.subjects[index].rooms.push(roomObj);
		}
		this.setState({ sharedRoomsForElective: tempElectiveObj });
	}

	componentWillMount() {
		let cellData = this.props.dataTableMap.get(this.props.cellCode);
		if (cellData.elective != undefined) {
			let elective = this.props.dataTableMap.get(this.props.cellCode).elective
			this.setState({
				isElective: true,
				elective: elective
			})
			this.showExistingSharedRoomForElectives();
		} else if (cellData.subject != undefined) {
			if (cellData.sharedRoomsForSubject !== undefined) {
				this.setState({ requiredRoom: cellData.sharedRoomsForSubject.room })
			}
			this.setState({ isElective: false })
			this.showExistingSharedRoom()
		}

	}

	onsave = () => {
		let requiredRoom = this.state.requiredRoom;
		requiredRoom = lodashUtil.uniqBy(requiredRoom, "name")
		let sharedRoomsForSubject = JSON.parse(JSON.stringify(this.state.sharedRoomsForSubject))
		sharedRoomsForSubject.room = []
		requiredRoom.map((roomName) => {
			sharedRoomsForSubject.room.push({
				roomId: roomName._id == undefined ? roomName.roomId : roomName._id,
				name: roomName.name,
				roomCode: roomName.roomCode
			})

		})

		this.state.sharedRoomsForSubject = JSON.parse(JSON.stringify(sharedRoomsForSubject))
	}

	onClickOfSave = async () => {
		this.onsave();
		let tempActiveSchool = this.state.tempActiveSchool;
		let keys = this.props.keys;
		let cellDetails = undefined;

		let gradeLevels = this.props.activeSchool.school_master.gradeLevels
		let objMatching = false;
		let templetObjForCreatingNewObj = undefined;
		let sharedRoomsForSubjects = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects
		let sharedRoomsForSubject = JSON.parse(JSON.stringify(this.state.sharedRoomsForSubject))
		sharedRoomsForSubject.showSharedRoomsForSubjectString = rulesUtil.getSharedRoomsForSubjectString(sharedRoomsForSubject.room);

		if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
			tempActiveSchool.schedule_constraints = [
				{ sharedRoomsForSubjects: [] }
			]
		}
		//KEYS 
		for (let c = 0; c < keys.length; c++) {
			cellDetails = this.props.dataTableMap.get(keys[c]);

			// gradeDetails from subject or elective 
			let cellGradeDetails = undefined;
			if (cellDetails.subject !== undefined) {
				cellGradeDetails = cellDetails.subject.gradeDetails
			} else if (cellDetails.elective !== undefined) {
				cellGradeDetails = cellDetails.elective.gradeDetails
			}
			// "EDIT" if sharedRoomsForSubjects is already present 
			if (cellDetails.sharedRoomsForSubject !== undefined) {
				//EDITING FOR GROUPS
				if (this.props.filter.showSections === true) {
					let count = 0;
					let index = undefined;
					let cellDetails_sharedRoomSubObj = cellDetails.sharedRoomsForSubject;

					let oldObj = cellDetails.sharedRoomsForSubject;
					let newObj = sharedRoomsForSubject;
					if (oldObj.room.length === newObj.room.length) {
						let checkingForSameRoomId = lodashUtil.differenceBy(oldObj.room, newObj.room, "roomId");
						if (checkingForSameRoomId.length === 0) {
							objMatching = true;
						}
					}

					if (objMatching === false) {
						// remove obj code 
						for (let d = 0; d < sharedRoomsForSubjects.length; d++) {
							let gradeObj = sharedRoomsForSubjects[d].gradeDetails.grades[0]
							if (cellDetails.subject && cellDetails.subject._id == sharedRoomsForSubjects[d].subjectId) {
								if (gradeObj.grade === cellDetails.grade) {
									count++
									if (gradeObj.groups.length === 0) {
										index = d;
									}

								}
							}
						}
						// SPLICE
						let subGradeObj;
						let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
						if (isLevelPresent !== undefined) {
							let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
							if (gradeLevelObj !== undefined)
								subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);

						} else {
							subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
						}
						// check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
						if (cellGradeDetails.allGrades === true || subGradeObj.groups.length === 0) {
							for (let p = 0; p < gradeLevels.length; p++) {
								let gradeLevel = gradeLevels[p]
								let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
								if (selectedObj !== undefined) {
									if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
										sharedRoomsForSubjects.splice(index, 1);
										break;
									}
								}
							}
						}
						// SUBJECT is there only for SOME GROUPS in that grade.
						else {
							if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
								sharedRoomsForSubjects.splice(index, 1);
							}
						}
					}
					// REPLACING the GROUPS if the group object was already present
					if (cellDetails_sharedRoomSubObj != undefined) {
						let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(sharedRoomsForSubjects, cellDetails_sharedRoomSubObj)
						if (objIndex != undefined) {
							tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects[objIndex].room = JSON.parse(JSON.stringify(sharedRoomsForSubject.room))
							tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects[objIndex].showSharedRoomsForSubjectString = sharedRoomsForSubject.showSharedRoomsForSubjectString
						}
					}
				}
				//"GRADES" show sections is false so we are clicking on grades which already has the data 
				else {
					// let = cellDetails.sharedRoomsForSubject._id;

					let oldObj = cellDetails.sharedRoomsForSubject;
					let newObj = sharedRoomsForSubject;
					if (oldObj.room.length === newObj.room.length) {
						let checkingForSameRoomId = lodashUtil.differenceBy(oldObj.room, newObj.room, "roomId");
						if (checkingForSameRoomId.length === 0) {
							objMatching = true;
						}
					}

					if (objMatching === false) {
						// REPLACING for all the groups and grades. Object should be over ridden with this value
						for (let h = 0; h < sharedRoomsForSubjects.length; h++) {

							if (cellDetails.subject && cellDetails.subject._id == sharedRoomsForSubjects[h].subjectId) {
								if (sharedRoomsForSubjects[h].gradeDetails.grades[0].grade === cellDetails.grade) {
									sharedRoomsForSubjects[h].room = JSON.parse(JSON.stringify(sharedRoomsForSubject.room));
									sharedRoomsForSubjects[h].showSharedRoomsForSubjectString = sharedRoomsForSubject.showSharedRoomsForSubjectString;

									if (sharedRoomsForSubjects[h].gradeDetails.grades[0].groups.length != 0) {
										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(sharedRoomsForSubjects[h]))
										}
									}
								}
							}
						}
					}
					this.creatingSharedRoomsForSubjectsObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
			}

			//"NEW OBJECT" if sharedRoom is not present in the schedule constraint
			else {
				// if the selected cell is for the grade and not for groups
				if (cellDetails.group === undefined) {
					//grade's object from master
					for (let g = 0; g < gradeLevels.length; g++) {
						let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
						//GRADE (groups is empty)
						if (gradeObj !== undefined) {
							let sharedRoomsForSubjectObj = JSON.parse(JSON.stringify(sharedRoomsForSubject));
							let gradeDetails = {
								allGrades: false,
								gradeLevels: [{
									level: cellDetails.gradeLevel
								}],
								grades: [{
									grade: cellDetails.grade,
									groups: [],
								}],
							}
							sharedRoomsForSubjectObj.gradeDetails = gradeDetails;
							tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects.push(sharedRoomsForSubjectObj);

							let existingGroupArray = [];
							for (let x = 0; x < sharedRoomsForSubjects.length; x++) {
								if (cellDetails.subject && cellDetails.subject._id == sharedRoomsForSubjects[x].subjectId) {
									if (sharedRoomsForSubjects[x].gradeDetails.grades[0].grade === cellDetails.grade
										&& sharedRoomsForSubjects[x].gradeDetails.grades[0].groups.length > 0) {
										existingGroupArray.push(sharedRoomsForSubjects[x].gradeDetails.grades[0].groups[0].groupCode)
										sharedRoomsForSubjects[x].room = JSON.parse(JSON.stringify(sharedRoomsForSubject.room));
										sharedRoomsForSubjects[x].showSharedRoomsForSubjectString = sharedRoomsForSubject.showSharedRoomsForSubjectString;

										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(sharedRoomsForSubjects[x]))
										}
									}
								}
							}
							// to create "NEW DATA" to all the GROUPS  
							//  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
							let commonGradeObj;
							let cellGrade
							let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
							if (isLevelPresent !== undefined) {
								let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
								if (gradeLevelObj !== undefined)
									cellGrade = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);

							} else {
								cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
							}
							let gradeObj = undefined
							for (let t = 0; gradeLevels.length; t++) {
								let gradeLevel = gradeLevels[t];
								if (gradeLevel.levelName === cellDetails.gradeLevel) {
									gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
								}
								if (gradeObj !== undefined) {
									break;
								}
							}
							if (cellGradeDetails.allGrades === true || cellGrade.groups.length === 0) {
								commonGradeObj = gradeObj;
							} else {
								commonGradeObj = cellGrade
							}
							for (let m = 0; m < commonGradeObj.groups.length; m++) {
								// AFTER GRADE => GROUPS
								if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
									let sharedRoomsForSubjectObj = JSON.parse(JSON.stringify(sharedRoomsForSubject));
									let gradeDetails = {
										allGrades: false,
										gradeLevels: [{
											level: cellDetails.gradeLevel
										}],
										grades: [{
											grade: cellDetails.grade,
											groups: [{
												groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
											}],
										}],
									}
									sharedRoomsForSubjectObj.gradeDetails = gradeDetails;
									tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects.push(sharedRoomsForSubjectObj);

									if (templetObjForCreatingNewObj === undefined) {
										templetObjForCreatingNewObj = JSON.parse(JSON.stringify(sharedRoomsForSubjectObj))
									}
								}
							}
							break;
						}
					}
					this.creatingSharedRoomsForSubjectsObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
				// selected cell for GROUPS
				else {
					let sharedRoomsForSubjectObj = JSON.parse(JSON.stringify(sharedRoomsForSubject));
					let gradeDetails = {
						allGrades: false,
						gradeLevels: [{
							level: cellDetails.gradeLevel
						}],
						grades: [{
							grade: cellDetails.grade,
							groups: [
								{ groupCode: cellDetails.group }
							],
						}],
					}
					sharedRoomsForSubjectObj.gradeDetails = gradeDetails;
					if (cellDetails.jointClass !== undefined) {
						sharedRoomsForSubjectObj.jointClassId = cellDetails.jointClass._id
					}

					sharedRoomsForSubjects.push(sharedRoomsForSubjectObj);

				}
			}
		}

		tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
			ConstraintsAndPreferences.Constants.REQUIRED_SHARED_ROOM_FOR_SUBJECTS)

		await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
		this.attachingDataToCell();
		this.props.handleCloseForDialog();
		this.props.handleClose();
		this.setState({
			requiredRoom: {},
			sharedRoomsForSubject: {
				room: []
			},
		})
	}

	creatingSharedRoomsForSubjectsObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
		let cellDetails_grade = cellDetails.grade
		let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		let sharedRoomsForSubjectsArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects

		//JOINT CLASS ARRAY
		for (let a = 0; a < jointClassArray.length; a++) {
			let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
			if (cellDetails.subject && cellDetails.subject._id == jointClassObj.subjectId) {
				let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

				let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
				if (gradeIndex != -1) {

					//JOINT CLASS GRADE 
					for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
						let gradeObj = gradeDetails_gradesArray[b]

						// JOINT CLASS GROUPS 
						for (let c = 0; c < gradeObj.groups.length; c++) {
							let groupObj = gradeObj.groups[c];
							let isGroupObjPresent = false;

							//SHARED ROOM FOR SUBJECTS FROM DATABASE
							for (let d = 0; d < sharedRoomsForSubjectsArray.length; d++) {
								let sharedRoomsForSubjectObj = sharedRoomsForSubjectsArray[d];
								let sharedRoomsForSubjectObj_grades = sharedRoomsForSubjectObj.gradeDetails.grades[0]
								// REPLACING THE VALUES IN THE DATABASE ARRAY
								if (sharedRoomsForSubjectObj_grades.grade === gradeObj.grade
									&& sharedRoomsForSubjectObj_grades.groups != undefined
									&& sharedRoomsForSubjectObj_grades.groups.length > 0
									&& sharedRoomsForSubjectObj_grades.groups[0].groupCode === groupObj.groupCode) {

									sharedRoomsForSubjectObj.room = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.room))
									sharedRoomsForSubjectObj.showSharedRoomsForSubjectString = templetObjForCreatingNewObj.showSharedRoomsForSubjectString
									sharedRoomsForSubjectObj.jointClassId = jointClassObj._id
									isGroupObjPresent = true
									break;
								}
							}

							// CREATE NEW OBJECT FOR PARTICULAR GROUPS
							if (isGroupObjPresent === false) {
								let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
								delete tempObj._id;
								tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
								tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
								tempObj.jointClassId = jointClassObj._id
								sharedRoomsForSubjectsArray.push(tempObj);
							}
						}
					}
				}
			}
		}
	}


	showExistingSharedRoom = () => {
		if (this.props.activeSchool.schedule_constraints !== undefined) {
			let room = this.state.sharedRoomsForSubject.room;
			let sharedRoomsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects
			if (sharedRoomsForSubjects !== undefined && sharedRoomsForSubjects.length > 0) {
				let celldetails = this.props.dataTableMap.get(this.props.cellCode)
				// groups is not present

				if (this.props.filter.showSections === false && celldetails.groups === undefined) {
					for (let b = 0; b < sharedRoomsForSubjects.length; b++) {
						if (sharedRoomsForSubjects[b].gradeDetails.grades[0].groups.length === 0) {
							if ((celldetails.subject && celldetails.subject._id == sharedRoomsForSubjects[b].subjectId) || (celldetails.elective && celldetails.elective._id == sharedRoomsForSubjects[b].electiveId)) {
								let grade = sharedRoomsForSubjects[b].gradeDetails.grades
								let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
								if (isObjectPresent !== undefined) {
									if (isObjectPresent.groups.length === 0) {
										let sharedRoomsForSubjectObject = JSON.parse(JSON.stringify(sharedRoomsForSubjects[b]))
										delete sharedRoomsForSubjectObject.gradeDetails
										this.setState({
											sharedRoomsForSubject: sharedRoomsForSubjectObject
										})
									}
								}
							}
						}
					}
				}
				// group is present
				if (this.props.filter.showSections === true && celldetails.group !== undefined) {
					for (let c = 0; c < sharedRoomsForSubjects.length; c++) {
						if (sharedRoomsForSubjects[c].gradeDetails.grades[0].groups.length !== 0) {
							if ((celldetails.subject && celldetails.subject._id == sharedRoomsForSubjects[c].subjectId) || (celldetails.elective && celldetails.elective._id == sharedRoomsForSubjects[c].electiveId)) {
								let grades = sharedRoomsForSubjects[c].gradeDetails.grades
								let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
								if (isObjPresent !== undefined) {
									let groupCode = isObjPresent.groups[0].groupCode
									if (groupCode === celldetails.group) {
										let sharedRoomsForSubjectObject = JSON.parse(JSON.stringify(sharedRoomsForSubjects[c]))
										delete sharedRoomsForSubjectObject.gradeDetails
										this.setState({
											sharedRoomsForSubject: sharedRoomsForSubjectObject
										})
									}
								}
							}
						}
					}
				}
			}
		}
	}


	attachingDataToCell = () => {
		let sharedRoomsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForSubjects;
		let dataTableMap = this.props.dataTableMap;
		for (let i = 0; i < sharedRoomsForSubjects.length; i++) {
			let grades = sharedRoomsForSubjects[i].gradeDetails.grades[0];

			// GRADE
			if (grades.groups.length === 0) {
				for (let [key, value] of dataTableMap) {
					if ((value.subject && value.subject._id == sharedRoomsForSubjects[i].subjectId)
						|| (value.elective && value.elective._id == sharedRoomsForSubjects[i].electiveId)) {
						if (value.grade === grades.grade) {
							value.sharedRoomsForSubject = sharedRoomsForSubjects[i];
							dataTableMap.set(key, value);
							break;
						}
					}
				}
			}
			//GROUPS
			else {
				for (let [key, value] of dataTableMap) {
					if ((value.subject && value.subject._id == sharedRoomsForSubjects[i].subjectId)
						|| (value.elective && value.elective._id == sharedRoomsForSubjects[i].electiveId)) {
						if (value.grade === grades.grade) {
							if (value.group === grades.groups[0].groupCode) {
								value.sharedRoomsForSubject = sharedRoomsForSubjects[i];
								dataTableMap.set(key, value);
								break;
							}
						}
					}
				}
			}
		}
	}

	showExistingSharedRoomForElectives = () => {
		if (this.props.activeSchool.schedule_constraints !== undefined) {
			let sharedRoomsForElectives = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForElectives
			if (sharedRoomsForElectives !== undefined && sharedRoomsForElectives.length > 0) {
				let celldetails = this.props.dataTableMap.get(this.props.cellCode)
				// groups is not present

				if (this.props.filter.showSections === false && celldetails.groups === undefined) {
					for (let b = 0; b < sharedRoomsForElectives.length; b++) {
						if (sharedRoomsForElectives[b].gradeDetails.grades[0].groups.length === 0) {
							if (celldetails.elective && celldetails.elective._id == sharedRoomsForElectives[b].electiveId) {
								let grade = sharedRoomsForElectives[b].gradeDetails.grades
								let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
								if (isObjectPresent !== undefined) {
									if (isObjectPresent.groups.length === 0) {

										let sharedRoomsForElectiveObject = JSON.parse(JSON.stringify(sharedRoomsForElectives[b]))
										delete sharedRoomsForElectiveObject.gradeDetails
										this.setState({
											sharedRoomsForElective: sharedRoomsForElectiveObject
										})
									}
								}
							}
						}
					}
				}
				// group is present
				if (this.props.filter.showSections === true && celldetails.group !== undefined) {
					for (let c = 0; c < sharedRoomsForElectives.length; c++) {
						if (sharedRoomsForElectives[c].gradeDetails.grades[0].groups.length !== 0) {
							if (celldetails.elective && celldetails.elective._id == sharedRoomsForElectives[c].electiveId) {
								let grades = sharedRoomsForElectives[c].gradeDetails.grades
								let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
								if (isObjPresent !== undefined) {
									let groupCode = isObjPresent.groups[0].groupCode
									if (groupCode === celldetails.group) {

										let sharedRoomsForElectiveObject = JSON.parse(JSON.stringify(sharedRoomsForElectives[c]))
										delete sharedRoomsForElectiveObject.gradeDetails
										this.setState({
											sharedRoomsForElective: sharedRoomsForElectiveObject
										})
									}
								}
							}
						}
					}
				}
			}
		}
	}


	onsaveForElevtives = () => {
		let tempSharedRoomsElectiveObj = this.state.sharedRoomsForElective;
		let subjectsArray = tempSharedRoomsElectiveObj.subjects;
		for (let i = 0; i < subjectsArray.length; i++) {
			let subject_roomsArray = subjectsArray[i].rooms;
			subject_roomsArray = lodashUtil.uniqBy(subject_roomsArray, "name");
			tempSharedRoomsElectiveObj.subjects[i].rooms = subject_roomsArray;
		}
		this.setState({
			sharedRoomsForElective: JSON.parse(JSON.stringify(tempSharedRoomsElectiveObj))
		})
	}

	onClickOfSaveForElective = async () => {
		this.onsaveForElevtives();
		let tempActiveSchool = this.state.tempActiveSchool;
		//tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].modifiedDate = new Date();
		let keys = this.props.keys;
		let cellDetails = undefined;
		let gradeLevels = this.props.activeSchool.school_master.gradeLevels
		let objMatching = false;
		let templetObjForCreatingNewObj = undefined;
		let sharedRoomsForElectives = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForElectives
		let sharedRoomsForElective = JSON.parse(JSON.stringify(this.state.sharedRoomsForElective))
		for (let x = 0; x < sharedRoomsForElective.subjects.length; x++) {
			let subjectObj = sharedRoomsForElective.subjects[x]
			subjectObj.showSharedRoomsForSubjectString = rulesUtil.getSharedRoomsForSubjectString(subjectObj.rooms)
		}

		if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
			tempActiveSchool.schedule_constraints = [
				{ sharedRoomsForElectives: [] }
			]
		}
		//KEYS 
		for (let c = 0; c < keys.length; c++) {
			cellDetails = this.props.dataTableMap.get(keys[c]);
			// gradeDetails from subject or elective 
			let cellGradeDetails = undefined;
			if (cellDetails.subject !== undefined) {
				cellGradeDetails = cellDetails.subject.gradeDetails
			} else if (cellDetails.elective !== undefined) {
				cellGradeDetails = cellDetails.elective.gradeDetails
			}
			// "EDIT" if sharedRoom is already present 
			if (cellDetails.sharedRoomsForElective !== undefined) {
				//EDITING FOR GROUPS
				if (this.props.filter.showSections === true) {
					let count = 0;
					let index = undefined;

					let cellDetails_Obj = cellDetails.sharedRoomsForElective;
					let state_Obj = sharedRoomsForElective
					for (let k = 0; k < state_Obj.subjects.length; k++) {
						let old_subject = cellDetails_Obj.subjects[k];
						let new_subject = state_Obj.subjects[k];
						if (old_subject.rooms.length === new_subject.rooms.length) {
							let checkingForSameRoomName = lodashUtil.differenceBy(old_subject.rooms, new_subject.rooms, "roomId");
							if (checkingForSameRoomName.length == 0) {
								objMatching = true;
							}
						} else {
							objMatching = false;
							break;
						}
					}
					if (objMatching === false) {
						// remove obj code 
						for (let d = 0; d < sharedRoomsForElectives.length; d++) {
							let gradeObj = sharedRoomsForElectives[d].gradeDetails.grades[0]
							if (cellDetails.elective && cellDetails.elective._id == sharedRoomsForElectives[d].electiveId) {
								if (gradeObj.grade === cellDetails.grade) {
									count++
									if (gradeObj.groups.length === 0) {
										index = d;
									}

								}
							}
						}

						// SPLICE
						let subGradeObj;
						let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
						if (isLevelPresent !== undefined) {
							let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
							if (gradeLevelObj !== undefined)
								subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);

						} else {
							subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
						}

						// check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
						if (cellGradeDetails.allGrades === true || subGradeObj.groups.length === 0) {
							for (let p = 0; p < gradeLevels.length; p++) {
								let gradeLevel = gradeLevels[p]
								let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
								if (selectedObj !== undefined) {
									if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
										sharedRoomsForElectives.splice(index, 1);
										break;
									}
								}
							}
						}

						// SUBJECT is there only for SOME GROUPS in that grade.
						else {
							if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
								sharedRoomsForElectives.splice(index, 1);
							}
						}
					}

					// REPLACING the GROUPS if the group object was already present
					let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(sharedRoomsForElectives, cellDetails_Obj)
					if (objIndex !== -1) {
						sharedRoomsForElectives[objIndex].subjects = JSON.parse(JSON.stringify(sharedRoomsForElective.subjects));
					}
				}

				//"GRADES" show sections is false so we are clicking on grades which already has the data 
				else {

					let cellDetails_Obj = cellDetails.sharedRoomsForElective;
					let state_Obj = sharedRoomsForElective
					for (let k = 0; k < state_Obj.subjects.length; k++) {
						let old_subject = cellDetails_Obj.subjects[k];
						let new_subject = state_Obj.subjects[k];
						if (old_subject.rooms.length === new_subject.rooms.length) {
							let checkingForSameRoomName = lodashUtil.differenceBy(old_subject.rooms, new_subject.rooms, "name");
							if (checkingForSameRoomName.length == 0) {
								objMatching = true;
							} else {
								objMatching = false;
								break
							}
						} else {
							objMatching = false;
							break;
						}
					}
					if (objMatching === false) {
						//all the groups should eb over ridden with this value
						for (let h = 0; h < sharedRoomsForElectives.length; h++) {

							if (cellDetails.elective && cellDetails.elective._id == sharedRoomsForElectives[h].electiveId) {
								if (sharedRoomsForElectives[h].gradeDetails.grades[0].grade === cellDetails.grade) {
									sharedRoomsForElectives[h].subjects = JSON.parse(JSON.stringify(sharedRoomsForElective.subjects));

									if (sharedRoomsForElectives[h].gradeDetails.grades[0].groups.length != 0) {
										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(sharedRoomsForElectives[h]))
										}
									}
								}
							}
						}
					}
					this.creatingSharedRoomsForElectivesObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
			}

			//"NEW OBJECT" if sharedRoom is not present in the schedule constraint
			else {
				// if the selected cell is for the grade and not for groups
				if (cellDetails.group === undefined) {
					//grade's object from master
					for (let g = 0; g < gradeLevels.length; g++) {
						let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
						//GRADE (groups is empty)
						if (gradeObj !== undefined) {
							let sharedRoomsForElectiveObj = JSON.parse(JSON.stringify(sharedRoomsForElective));
							let gradeDetails = {
								allGrades: false,
								gradeLevels: [{
									level: cellDetails.gradeLevel
								}],
								grades: [{
									grade: cellDetails.grade,
									groups: [],
								}],
							}
							sharedRoomsForElectiveObj.gradeDetails = gradeDetails;
							tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForElectives.push(sharedRoomsForElectiveObj);

							let existingGroupArray = [];

							for (let x = 0; x < sharedRoomsForElectives.length; x++) {
								if (cellDetails.elective && cellDetails.elective._id == sharedRoomsForElectives[x].electiveId) {
									if (sharedRoomsForElectives[x].gradeDetails.grades[0].grade === cellDetails.grade
										&& sharedRoomsForElectives[x].gradeDetails.grades[0].groups.length > 0) {

										existingGroupArray.push(sharedRoomsForElectives[x].gradeDetails.grades[0].groups[0].groupCode)
										sharedRoomsForElectives[x].subjects = JSON.parse(JSON.stringify(sharedRoomsForElective.subjects));

										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(sharedRoomsForElectives[x]))
										}
									}
								}
							}

							// to create NEW DATA to all the GROUPS  
							//  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
							let commonGradeObj;
							let cellGrade
							let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
							if (isLevelPresent !== undefined) {
								let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
								if (gradeLevelObj !== undefined)
									cellGrade = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);

							} else {
								cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
							}
							let gradeObj = undefined
							for (let t = 0; gradeLevels.length; t++) {
								let gradeLevel = gradeLevels[t];
								if (gradeLevel.levelName === cellDetails.gradeLevel) {
									gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
								}
								if (gradeObj !== undefined) {
									break;
								}
							}
							if (cellGradeDetails.allGrades === true || cellGrade.groups.length === 0) {
								commonGradeObj = gradeObj;
							} else {
								commonGradeObj = cellGrade
							}

							for (let m = 0; m < commonGradeObj.groups.length; m++) {
								// AFTER GRADE => GROUPS
								if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
									let sharedRoomsForElectiveObj = JSON.parse(JSON.stringify(sharedRoomsForElective));
									let gradeDetails = {
										allGrades: false,
										gradeLevels: [{
											level: cellDetails.gradeLevel
										}],
										grades: [{
											grade: cellDetails.grade,
											groups: [{
												groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
											}],
										}],
									}
									sharedRoomsForElectiveObj.gradeDetails = gradeDetails;
									tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForElectives.push(sharedRoomsForElectiveObj);

									if (templetObjForCreatingNewObj === undefined) {
										templetObjForCreatingNewObj = JSON.parse(JSON.stringify(sharedRoomsForElectiveObj))
									}
								}
							}
							break;
						}
					}
					this.creatingSharedRoomsForElectivesObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
				// selected cell for GROUPS
				else {
					let sharedRoomsForElectiveObj = JSON.parse(JSON.stringify(sharedRoomsForElective));
					let gradeDetails = {
						allGrades: false,
						gradeLevels: [{
							level: cellDetails.gradeLevel
						}],
						grades: [{
							grade: cellDetails.grade,
							groups: [
								{ groupCode: cellDetails.group }
							],
						}],
					}
					sharedRoomsForElectiveObj.gradeDetails = gradeDetails;
					if (cellDetails.jointClass !== undefined) {
						sharedRoomsForElectiveObj.jointClassId = cellDetails.jointClass._id
					}
					sharedRoomsForElectives.push(sharedRoomsForElectiveObj);
				}

			}
		}
		tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
			ConstraintsAndPreferences.Constants.REQUIRED_SHARED_ROOM_FOR_ELECTIVES)

		await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
		this.attachingDataToCellForElectives();
		this.props.handleCloseForDialog();
		this.props.handleClose();
		this.setState({
			sharedRoomsForElective: {},
		})
	}

	creatingSharedRoomsForElectivesObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
		let cellDetails_grade = cellDetails.grade
		let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		let sharedRoomsForElectivesArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForElectives

		//JOINT CLASS ARRAY
		for (let a = 0; a < jointClassArray.length; a++) {
			let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
			if (cellDetails.elective && cellDetails.elective._id == jointClassObj.electiveId) {
				let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

				let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
				if (gradeIndex != -1) {

					//JOINT CLASS GRADE 
					for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
						let gradeObj = gradeDetails_gradesArray[b]

						// JOINT CLASS GROUPS 
						for (let c = 0; c < gradeObj.groups.length; c++) {
							let groupObj = gradeObj.groups[c];
							let isGroupObjPresent = false;

							//SHARED ROOM FOR ELECTIVE FROM DATABASE
							for (let d = 0; d < sharedRoomsForElectivesArray.length; d++) {
								let sharedRoomsForElectiveObj = sharedRoomsForElectivesArray[d];
								let sharedRoomsForElectiveObj_grades = sharedRoomsForElectiveObj.gradeDetails.grades[0]
								// REPLACING THE VALUES IN THE DATABASE ARRAY
								if (sharedRoomsForElectiveObj_grades.grade === gradeObj.grade
									&& sharedRoomsForElectiveObj_grades.groups != undefined
									&& sharedRoomsForElectiveObj_grades.groups.length > 0
									&& sharedRoomsForElectiveObj_grades.groups[0].groupCode === groupObj.groupCode) {

									sharedRoomsForElectiveObj.subjects = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.subjects))
									sharedRoomsForElectiveObj.jointClassId = jointClassObj.jointClassId
									isGroupObjPresent = true
									break;
								}
							}

							// CREATE NEW OBJECT FOR PARTICULAR GROUPS
							if (isGroupObjPresent === false) {
								let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
								delete tempObj._id;
								tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
								tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
								tempObj.jointClassId = jointClassObj.jointClassId
								sharedRoomsForElectivesArray.push(tempObj);
							}
						}
					}
				}
			}
		}
	}

	attachingDataToCellForElectives = () => {
		let sharedRoomsForElectives = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].sharedRoomsForElectives;
		let dataTableMap = this.props.dataTableMap;
		for (let i = 0; i < sharedRoomsForElectives.length; i++) {
			let grades = sharedRoomsForElectives[i].gradeDetails.grades[0];
			// GRADE
			if (grades.groups.length === 0) {
				for (let [key, value] of dataTableMap) {
					if ((value.subject && value.subject._id == sharedRoomsForElectives[i].subjectId)
						|| (value.elective && value.elective._id == sharedRoomsForElectives[i].electiveId)) {
						if (value.grade === grades.grade) {
							value.sharedRoomsForElective = sharedRoomsForElectives[i];
							dataTableMap.set(key, value);
							break;
						}
					}
				}
			}
			//GROUPS
			else {
				for (let [key, value] of dataTableMap) {
					if ((value.subject && value.subject._id == sharedRoomsForElectives[i].subjectId)
						|| (value.elective && value.elective._id == sharedRoomsForElectives[i].electiveId)) {
						if (value.grade === grades.grade) {
							if (value.group === grades.groups[0].groupCode) {
								value.sharedRoomsForElective = sharedRoomsForElectives[i];
								dataTableMap.set(key, value);
								break;
							}
						}
					}
				}
			}
		}
	}

	render() {
		return (
			<React.Fragment>
				{this.state.isElective === true ?
					<RequiredSharedRoomForElectives
						{...this.state}
						{...this.props}
						handleChangeNameforElective={this.handleChangeNameforElective}
						onClickOfSaveForElective={this.onClickOfSaveForElective}
					/>
					:
					<RequiredSharedRoomComponent
						{...this.state}
						{...this.props}
						handleChangeName={this.handleChangeName}
						onClickOfSave={this.onClickOfSave}
					/>
				}
			</React.Fragment>
		)
	}
}

export default RequiredSharedRoomContainer
